/**
 * Grid Gallery Configuration
 * iPhone Photos-style grid where zoom changes column count
 */

export interface GridZoomLevel {
  columns: number
  gap: number
}

export const gridGalleryConfig = {
  // Cell aspect ratio: 3/4 matches iPhone portrait photos so they show fully
  // Change to 1 for square cells, or 2/3 for taller cells
  // 9:16 portrait - the phone shape. Measured 2026-09-08 on the newest 1,000
  // gallery images: 860 are 9:16 (3213x5712, 2268x4032, 1080x1920...), 128
  // are 3:4, 12 landscape. Cells no longer crop; the few non-9:16 images sit
  // on their dominant colour with bars.
  cellAspectRatio: 9 / 16,

  // Each zoom level defines a column count and gap
  // Index 0 = most zoomed out, last = most zoomed in
  zoomLevels: [
    { columns: 40, gap: 0 },
    { columns: 30, gap: 0 },
    { columns: 20, gap: 1 },
    { columns: 14, gap: 1 },
    { columns: 10, gap: 1 },
    { columns: 7, gap: 2 },
    { columns: 5, gap: 2 },
    { columns: 3, gap: 2 },
    { columns: 2, gap: 3 },
    { columns: 1, gap: 0 },
  ] as GridZoomLevel[],

  // Default zoom index per device type
  defaultZoomIndex: {
    mobile: 6,   // 5 columns
    desktop: 5,  // 7 columns
  },

  // Image quality based on how many images are visible on screen
  qualityThresholds: {
    full: 4,       // <= 4 images visible -> full quality (1-2 columns)
    medium: 15,    // <= 15 images -> medium quality (3-5 columns)
    thumbnail: 100, // <= 100 images -> thumbnail (CloudFront cached)
    // > 100 images -> still thumbnail (they're cached anyway)
  },

  // Virtualization settings
  virtualization: {
    bufferRows: 5,  // render extra rows above/below viewport
  },

  // Animation settings
  animation: {
    zoomTransitionMs: 250,
  },

  // Pinch gesture thresholds
  pinch: {
    zoomInRatio: 1.3,   // pinch spread by 30% to zoom in
    zoomOutRatio: 0.7,  // pinch shrink by 30% to zoom out
  },

  // Thumbnail preloading
  preload: {
    thumbnailsAhead: 100,  // preload this many thumbnails beyond visible range
  },

  // Premium overlay visibility
  // Only show lock/price/purchase UI when zoomed in to this many columns or fewer.
  // When zoomed out further, locked images just show the blurry placeholder.
  premiumOverlayMaxColumns: 2,
}

export default gridGalleryConfig
